import React from 'react';
import { TrendingUp, AlertCircle } from 'lucide-react';

export default function DemandForecastingChart({ data }) {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-green-600" />
          Prévision Demande
        </h2>
        <p className="text-gray-500 text-center py-8">Données insuffisantes pour prévision</p>
      </div>
    );
  }

  const maxValue = Math.max(...data?.map(d => d?.upper || 0));

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-green-600" />
        Prévision Demande (3 mois)
      </h2>
      
      <div className="space-y-6">
        {data?.map((item, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">{item?.month}</span>
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-green-600">
                  {item?.predicted} unités
                </span>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  item?.confidence >= 80 ? 'bg-green-100 text-green-700' :
                  item?.confidence >= 60 ? 'bg-yellow-100 text-yellow-700': 'bg-red-100 text-red-700'
                }`}>
                  {item?.confidence}% confiance
                </span>
              </div>
            </div>
            
            {/* Confidence interval visualization */}
            <div className="relative h-12 bg-gray-100 rounded-lg overflow-hidden">
              {/* Lower bound */}
              <div
                className="absolute left-0 top-0 h-full bg-green-200"
                style={{ width: `${(item?.lower / maxValue) * 100}%` }}
              ></div>
              
              {/* Predicted value */}
              <div
                className="absolute left-0 top-0 h-full bg-green-500"
                style={{ width: `${(item?.predicted / maxValue) * 100}%` }}
              ></div>
              
              {/* Upper bound marker */}
              <div
                className="absolute top-0 h-full w-1 bg-green-700"
                style={{ left: `${(item?.upper / maxValue) * 100}%` }}
              ></div>
              
              {/* Value labels */}
              <div className="absolute inset-0 flex items-center justify-between px-3 text-xs font-medium">
                <span className="text-gray-700">{item?.lower}</span>
                <span className="text-white">{item?.predicted}</span>
                <span className="text-gray-700">{item?.upper}</span>
              </div>
            </div>
            
            <div className="flex items-center justify-between mt-1 text-xs text-gray-500">
              <span>Intervalle: {item?.lower} - {item?.upper}</span>
              <span>±{Math.round(((item?.upper - item?.lower) / item?.predicted) * 100)}%</span>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex items-start gap-2 text-sm text-gray-600">
          <AlertCircle className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
          <p>
            Prévisions basées sur moyennes mobiles et tendances historiques. 
            La confiance diminue avec l'horizon temporel.
          </p>
        </div>
      </div>
    </div>
  );
}